export default __webpack_public_path__ + "static/media/SackBasics1.fec74a3b.jpg";